import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AbilityContext } from 'components/Can';
import AppMenuItem from './AppMenuitem';
import { MenuProvider } from './context/menucontext';

function AppMenu() {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const model = [
    {
      label: t('menu.dashboard.label'),
      items: [{ label: t('menu.dashboard.items.dashboard'), icon: 'pi pi-fw pi-home', to: '/' }],
    },
    {
      label: t('menu.proposal.label'),
      items: [
        {
          label: t('menu.proposal.items.proposal'),
          icon: 'pi pi-fw pi-list',
          to: '/proposals',
        },
      ],
    },
    {
      label: t('menu.projectProposal.label'),
      items: [
        {
          label: t('menu.projectProposal.items.reviseProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-revise',
        },
        {
          label: t('menu.projectProposal.items.submitProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-submit',
        },
        {
          label: t('menu.projectProposal.items.completedProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-completed',
        },
        {
          label: t('menu.projectProposal.items.councilProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/councils',
        },
      ],
    },

    // for partner
    {
      label: t('menu.pubProjectProposal.label'),
      items: [
        {
          label: t('menu.pubProjectProposal.items.revisePubProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/pub-projects-revise',
        },
        // {
        //   label: t('menu.pubProjectProposal.items.submitPubProjectList'),
        //   icon: 'pi pi-fw pi-list',
        //   to: '/partner-projects-submit',
        // },
        // {
        //   label: t('menu.pubProjectProposal.items.completedPubProjectList'),
        //   icon: 'pi pi-fw pi-list',
        //   to: '/partner-projects-completed',
        // },
      ],
    },
    {
      label: t('menu.administration.label'),
      items: [
        {
          label: t('menu.administration.items.employee'),
          icon: 'pi pi-fw pi-users',
          to: '/employee',
        },
        {
          label: t('menu.administration.items.organization'),
          icon: 'pi pi-fw pi-building',
          to: '/organization',
        },
        {
          label: t('menu.administration.items.KpiGroup'),
          icon: 'pi pi-fw pi-tags',
          to: '/research-kpi-group',
        },
        {
          label: t('menu.administration.items.researchField'),
          icon: 'pi pi-fw pi-sitemap',
          to: '/research-field',
        },
        {
          label: t('menu.administration.items.bonusExpenditure'),
          icon: 'pi pi-fw pi-dollar',
          to: '/bonus-expenditure',
        },
        {
          label: t('menu.administration.items.program'),
          icon: 'pi pi-fw pi-server',
          to: '/program',
        },
        {
          label: t('menu.administration.items.programProposal'),
          icon: 'pi pi-fw pi-server',
          to: '/program-proposal',
        },
        {
          label: t('menu.administration.items.statistics'),
          icon: 'pi pi-fw pi-chart-bar',
          to: '/statistics',
        },
        {
          label: t('menu.administration.items.forms'),
          icon: 'pi pi-fw pi-file',
          to: '/forms',
        },
      ],
    },
  ];

  if (
    ability.cannot('read', 'employee') &&
    ability.cannot('read', 'organization') &&
    ability.cannot('read', 'research_kpi_group') &&
    ability.cannot('read', 'research_kpi') &&
    ability.cannot('read', 'research_field') &&
    ability.cannot('read', 'program') &&
    ability.cannot('read', 'statistic_detail') &&
    ability.cannot('read', 'bonus_expenditure') &&
    ability.cannot('read', 'proposal_program')
  ) {
    delete model[4];
  } else {
    if (ability.cannot('read', 'statistic_detail')) {
      delete model[4].items[7];
    }

    if (ability.cannot('read', 'proposal_program')) {
      delete model[4].items[6];
    }
    if (ability.cannot('read', 'program')) {
      delete model[4].items[5];
    }
    if (ability.cannot('read', 'bonus_expenditure')) {
      delete model[4].items[4];
    }
    if (ability.cannot('read', 'research_field')) {
      delete model[4].items[3];
    }
    if (ability.cannot('read', 'research_kpi') || ability.cannot('read', 'research_kpi_group')) {
      delete model[4].items[2];
    }
    if (ability.cannot('read', 'organization')) {
      delete model[4].items[1];
    }
    if (ability.cannot('read', 'employee')) {
      delete model[4].items[0];
    }
  }

  if (ability.cannot('read', 'pub_project_proposal')) {
    delete model[3];
  }

  if (ability.cannot('read', 'project_proposal')) {
    delete model[2];
  }

  if (ability.cannot('read', 'proposal')) {
    delete model[1];
  }

  if (ability.cannot('read', 'statistic')) {
    delete model[0];
  }

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {model.map((item, index) =>
          !item.seperator ? (
            <AppMenuItem key={item.label} item={item} root index={index} />
          ) : (
            <li className="menu-separator" />
          )
        )}
      </ul>
    </MenuProvider>
  );
}

export default AppMenu;
